import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';

const ParagraphBlock = ({ data, onChange }) => {
  const modules = useMemo(() => ({
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['link'],
    ],
  }), []);

  return (
    <div className="mb-3">
      <ReactQuill
        theme="snow"
        value={data.text}
        onChange={(value) => onChange({ ...data, text: value })}
        modules={modules}
        placeholder="Write your paragraph here..."
      />
    </div>
  );
};

export default ParagraphBlock;

// import React from 'react';
// import QuillTextEditor from '../../../../components/QuillTextEditor';

// const ParagraphBlock = ({ data, onChange }) => {
//   return (
//     <div className="mb-3">
//       <QuillTextEditor
//         value={data.text}
//         onChange={(value) => onChange({ ...data, text: value })}
//       />
//     </div>
//   );
// };

// export default ParagraphBlock;
